/* eslint-disable react/forbid-prop-types */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Provider as ReduxProvider } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
import StyleContext from 'isomorphic-style-loader/StyleContext';

import DefaultHeadContent from 'components/DefaultHeadContent';
import HeadContent from 'components/HeadContent';
import ImpersonationBanner from 'components/ImpersonationBanner';
import ScrollPositionManager from 'components/ScrollPositionManager';
import history from 'services/history';
import { setIsBackNavigation } from 'actions/router';

import ApplicationContext from './ApplicationContext';

export default function App({ context, styleContext, apolloClient, store, children }) {
  // Add a centralized history listener to track back button navigation
  useEffect(
    () => {
      const unlisten = history.listen((_, action) => {
        console.info('App.js - history action = ', action);
        // POP action means the user navigated using back or forward buttons
        store.dispatch(setIsBackNavigation(action === 'POP'));
      });

      return () => {
        unlisten();
      };
    },
    [store],
  );

  // NOTE: If you need to add or modify header, footer etc. of the app,
  // please do that inside the Layout component.
  return (
    <StyleContext.Provider value={styleContext}>
      <ApplicationContext.Provider value={context}>
        <ReduxProvider store={store}>
          <ApolloProvider client={apolloClient}>
            <ScrollPositionManager location={history.location} />
            <DefaultHeadContent />
            <HeadContent
              contents={{
                robots: true,
                common: true,
              }}
            />
            <ImpersonationBanner />
            {React.Children.only(children)}
          </ApolloProvider>
        </ReduxProvider>
      </ApplicationContext.Provider>
    </StyleContext.Provider>
  );
}

App.propTypes = {
  // Enables critical path CSS rendering
  // https://github.com/kriasoft/isomorphic-style-loader
  styleContext: PropTypes.object.isRequired,
  apolloClient: PropTypes.object.isRequired,
  store: PropTypes.object.isRequired,
  context: PropTypes.shape({
    fetch: PropTypes.func.isRequired,
    pathname: PropTypes.string.isRequired,
    query: PropTypes.object,
  }).isRequired,
  children: PropTypes.element.isRequired,
};
